import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/coursewares/loading.gif'
import _imports_1 from '@/assets/coursewares/clickDownload.png'
import _imports_2 from '@/assets/coursewares/done.png'
import _imports_3 from '@/assets/coursewares/failed.png'


_pushScopeId("data-v-2e5aef43")
const _hoisted_1 = { class: "transfer-progress-container" }
const _hoisted_2 = {
  key: 0,
  class: "transfer-progress-info"
}
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = { class: "no-task" }
const _hoisted_5 = { class: "content-left" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "content-filename" }
const _hoisted_8 = { class: "content-progress" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "tab-content" }
const _hoisted_13 = { class: "no-task" }
const _hoisted_14 = { class: "content-left" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "content-filename" }
const _hoisted_17 = { class: "content-progress-done" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  title: "点击下载",
  alt: ""
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_22 = { class: "tab-content" }
const _hoisted_23 = { class: "no-task" }
const _hoisted_24 = { class: "content-left" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "content-filename" }
const _hoisted_27 = { class: "content-progress" }
const _hoisted_28 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_29 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
_popScopeId()


import {
  reactive,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  toRaw
} from 'vue'
import emitter, { EmitterEvents } from '@/utils/common/emitter'
import { CloseOutlined } from '@ant-design/icons-vue'

const __default__ = { name: 'TransferProgress' }

function setup(__props) {

const statusConstantMap = {
  PENDING: 'pending',
  START: 'start',
  DOING: 'doing',
  DONE: 'done',
  FAILED: 'failed'
}
// 传输的所有任务
const coursewareTasks = reactive([] as any[])
const activeKey = ref('1')

const addCourseWareTask = job => {
  coursewareTasks.push(...job)
  activeKey.value = '1'
  isShowProgress.value = true
}
// 根据任务的状态排序，doing在最前，pending在最后
const sortByStatus = tasks => {
  const orderMap = {
    doing: 1,
    start: 2,
    pending: 3
  }
  tasks.sort((prev, next) => {
    return orderMap[prev.status] - orderMap[next.status]
  })
}
// 传输进度更新
const onCourseWareTaskProgress = job => {
  if (job.progress === 100) {
    emitter.emit(EmitterEvents.ON_TASK_PROGRESS, toRaw(job))
  }
  // console.log('ON_COURSEWARE_TASK_PROGRESS', job)
  const oldIndex = coursewareTasks.findIndex(task => {
    return task.id === job.id
  })
  oldIndex !== -1 && coursewareTasks.splice(oldIndex, 1, job)
  sortByStatus(noCompleteTasksObj.value.noCompleteTasks)
}
onMounted(() => {
  // 监听传输任务的添加和进度更新
  emitter.on(EmitterEvents.ADD_COURSEWARE_TASK, addCourseWareTask)
  emitter.on(
    EmitterEvents.ON_COURSEWARE_TASK_PROGRESS,
    onCourseWareTaskProgress
  )
})
// 未完成的任务
const noCompleteTasksObj = computed(() => {
  const noCompleteTasks = coursewareTasks.filter(task => {
    return (
      task.status !== statusConstantMap.DONE &&
      task.status !== statusConstantMap.FAILED
    )
  })
  const doingTasks = noCompleteTasks.filter(task => {
    return task.status === statusConstantMap.DOING
  })
  const noCompleteTasksLen = noCompleteTasks.length
  const doingTasksLen = doingTasks.length
  const isDoing = `${doingTasksLen}/${noCompleteTasksLen}`
  return {
    noCompleteTasks,
    isDoing
  }
})
// 成功的任务
const doneTasksObj = computed(() => {
  const doneTasks = coursewareTasks.filter(task => {
    return task.status === statusConstantMap.DONE
  })
  const doneTasksLen = doneTasks.length
  return {
    doneTasks,
    doneTasksLen
  }
})
// 失败的任务
const failedTasksObj = computed(() => {
  const failedTasks = coursewareTasks.filter(task => {
    return task.status === statusConstantMap.FAILED
  })
  const failedTasksLen = failedTasks.length
  return {
    failedTasks,
    failedTasksLen
  }
})

onBeforeUnmount(() => {
  emitter.off(EmitterEvents.ADD_COURSEWARE_TASK, addCourseWareTask)
  emitter.off(
    EmitterEvents.ON_COURSEWARE_TASK_PROGRESS,
    onCourseWareTaskProgress
  )
})

const uploadingPath = require('@/assets/coursewares/uploading.png')
const downloadingPath = require('@/assets/coursewares/downloading.png')
// 是否显示传输进度详情
const isShowProgress = ref(false)

const handleShowProgress = (flag: boolean) => {
  isShowProgress.value = flag
}
// 下载类任务传输完成后点击下载按钮
const clickDownload = task => {
  emitter.emit(EmitterEvents.ON_TASK_CLICK, toRaw(task))
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isShowProgress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_tabs, {
            activeKey: activeKey.value,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => (activeKey.value = $event)),
            size: "small",
            tabBarGutter: 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "1",
                tab: `正在传输(${_unref(noCompleteTasksObj).isDoing})`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("div", _hoisted_4, " 当前没有任务 ", 512), [
                      [_vShow, _unref(noCompleteTasksObj).noCompleteTasks.length === 0]
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noCompleteTasksObj).noCompleteTasks, (task) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: task.id,
                        class: "info-content"
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            class: "transfer-status",
                            src: 
                    task.type === 'uploadCourseware'
                      ? _unref(uploadingPath)
                      : _unref(downloadingPath)
                  
                          }, null, 8, _hoisted_6),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(task.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _withDirectives(_createElementVNode("span", { class: "progress-number" }, _toDisplayString(task.progress.toFixed() + "%"), 513), [
                            [_vShow, task.status === statusConstantMap.DOING]
                          ]),
                          (task.status === statusConstantMap.DOING)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                            : (task.status === statusConstantMap.START)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "准备" + _toDisplayString(task.type === "downloadCourseware" ? "下载" : "上传"), 1))
                              : (task.status === statusConstantMap.PENDING)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "等待" + _toDisplayString(task.type === "downloadCourseware" ? "下载" : "上传"), 1))
                                : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["tab"]),
              _createVNode(_component_a_tab_pane, {
                key: "2",
                tab: `传输成功(${_unref(doneTasksObj).doneTasksLen})`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("div", _hoisted_13, " 当前没有任务 ", 512), [
                      [_vShow, _unref(doneTasksObj).doneTasksLen === 0]
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(doneTasksObj).doneTasks, (task) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: task.id,
                        class: "info-content"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("img", {
                            class: "transfer-status",
                            src: 
                    task.type === 'uploadCourseware'
                      ? _unref(uploadingPath)
                      : _unref(downloadingPath)
                  
                          }, null, 8, _hoisted_15),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(task.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          (task.type === 'downloadCourseware')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "click-download",
                                onClick: ($event: any) => (clickDownload(task))
                              }, _hoisted_20, 8, _hoisted_18))
                            : (_openBlock(), _createElementBlock("img", _hoisted_21))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["tab"]),
              _createVNode(_component_a_tab_pane, {
                key: "3",
                tab: `传输失败(${_unref(failedTasksObj).failedTasksLen})`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("div", _hoisted_23, " 当前没有任务 ", 512), [
                      [_vShow, _unref(failedTasksObj).failedTasksLen === 0]
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(failedTasksObj).failedTasks, (task) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: task.id,
                        class: "info-content"
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("img", {
                            class: "transfer-status",
                            src: 
                    task.type === 'uploadCourseware'
                      ? _unref(uploadingPath)
                      : _unref(downloadingPath)
                  
                          }, null, 8, _hoisted_25),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(task.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (task?.extra?.errorType === 'CLOUD_SPACE_OVER')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString('云空间不足')))
                            : (_openBlock(), _createElementBlock("img", _hoisted_29))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["tab"])
            ]),
            _: 1
          }, 8, ["activeKey"]),
          _createVNode(_unref(CloseOutlined), {
            class: "close-progress-info",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleShowProgress(false)))
          })
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "no-progress",
      style: _normalizeStyle({
        height: isShowProgress.value ? '191px' : 'auto'
      })
    }, null, 4), [
      [_vShow, !isShowProgress.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "transfer-progress-button",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleShowProgress(!isShowProgress.value)))
    }, " 【任务中心】 任务进行中，请勿跳转页面！ ", 512), [
      [_vShow, _unref(noCompleteTasksObj).noCompleteTasks.length !== 0]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "transfer-progress-button",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (handleShowProgress(!isShowProgress.value)))
    }, " 【任务中心】 当前没有任务！ ", 512), [
      [_vShow, _unref(noCompleteTasksObj).noCompleteTasks.length === 0]
    ])
  ]))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})